// authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'authInfo',
  initialState: {
    isModalOpen: false,
    currentStep: 'phone', // 'phone', 'otp', 'verified'
    phoneNumber: '',
    otp: '',
    otpTimer: 120, // 2 minutes in seconds
    canResend: false,
    error: null,
    loading: false, // Added loading state
  },
  reducers: {
    openModal: (state) => {
      state.isModalOpen = true;
      state.currentStep = 'phone';
      state.error = null;
      state.loading = false;
    },
    closeModal: (state) => {
      state.isModalOpen = false;
      state.currentStep = 'phone';
      state.phoneNumber = '';
      state.otp = '';
      state.error = null;
      state.otpTimer = 120;
      state.canResend = false;
      state.loading = false;
    },
    setPhoneNumber: (state, action) => {
      state.phoneNumber = action.payload;
    },
    setOtp: (state, action) => {
      state.otp = action.payload;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
      // Clear error when changing steps
      state.error = null;
    },
    decrementTimer: (state) => {
      if (state.otpTimer > 0) {
        state.otpTimer -= 1;
        // Update canResend based on timer (enable when 60 seconds or less remain)
        state.canResend = state.otpTimer <= 60;
      }
    },
    resetTimer: (state) => {
      state.otpTimer = 120;
      state.canResend = false;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false; // Clear loading when error occurs
    },
    clearError: (state) => {
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
      // Clear error when starting loading
      if (action.payload) {
        state.error = null;
      }
    },
    // Helper action to reset OTP related state
    resetOtpState: (state) => {
      state.otp = '';
      state.otpTimer = 120;
      state.canResend = false;
    },
  },
});

export const {
  openModal,
  closeModal,
  setPhoneNumber,
  setOtp,
  setCurrentStep,
  decrementTimer,
  resetTimer,
  setError,
  clearError,
  setLoading,
  resetOtpState,
} = authSlice.actions;

export default authSlice.reducer;
